const SEARCH_TYPES = {
  REGULAR: 'regular',
  FLAGGED: 'flagged',
  DELETED: 'deleted',
  UNFINISHED: 'unfinished',
};

export default SEARCH_TYPES;
